import ViewController from "core/views/view.controller";
import Moment from "moment/moment";
import {Item, Items} from "core/model/items.model";

export default class NewBookingTimeCtrl extends ViewController {
    static $inject = ['$scope', '$state', '$ionicHistory', 'Bookings'];

    constructor() {
        super(...arguments);

        this.booking = null;
        this.time = null;
        this.timeItems = null;
        this.timeInterval = 5;
    }

    $onViewBeforeEnter() {
        this.loadBookingState();

        this.loadFreeTimes().then((times)=> {
            this.timeItems = this.createTimeItems(times, this.booking.startTime);
        });
    }

    prev() {
        this.saveBookingState();
        this.$ionicHistory.goBack();
    }

    next() {
        if(!this.timeItems.hasSelected()){
            return;
        }

        this.saveBookingState();
        this.toState('tab.new-booking-options');
    }

    loadBookingState() {
        this.booking = this.viewState('booking');
    }

    saveBookingState() {
        if (this.timeItems) {
            this.booking.startTime = this.timeItems.selectedValue();
            this.booking.endTime = Moment(this.booking.startTime).add('minutes', this.booking.duration).format();
        }

        this.viewState('booking', this.booking);
    }

    selectTime(timeItem) {
        timeItem.selected = true;
        this.next();
    }

    loadFreeTimes() {
        return this.Bookings.freeTimes(
            this.booking.date,
            this.booking.services,
            this.booking.resources,
            this.booking.duration,
            this.timeInterval
        );
    }

    createTimeItems(times, selectedTime) {
        var timeItems = Items.create(times);
        timeItems.singleSelection = true;

        if (selectedTime) {
            timeItems.selectBy(selectedTime);
        }

        return timeItems;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/views/new-booking-time/new-booking-time.controller.js